var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"consumer-public",staticStyle:{"min-height":"100vh!important"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"max-height-limit",staticStyle:{"min-height":"90vh"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }